import React from 'react';
import { Linkedin, Twitter, Instagram } from 'lucide-react';

const Footer = () => {
  const socials = [
    {
      name: "LinkedIn",
      url: "https://linkedin.com/in/tsvetan-dimitrov",
      icon: Linkedin
    },
    {
      name: "X (Twitter)",
      url: "https://x.com/tsvtxt",
      icon: Twitter
    },
    {
      name: "Instagram",
      url: "https://instagram.com/dimitrovovich",
      icon: Instagram
    }
  ];

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-socials">
            {socials.map((social, index) => {
              const IconComponent = social.icon;
              return (
                <a 
                  key={index}
                  href={social.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="social-link"
                  title={social.name}
                >
                  <IconComponent size={16} className="social-icon" />
                  <span className="social-name">{social.name}</span>
                </a>
              );
            })}
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;